import Service from "../../../Services/index";

const machine = {
    namespaced: true,
    state: {
        form : {
            id : "",
            name : "",
            description: "",
            time_shot : ""
        },
        machine_product_list : [],
        dataPaginate:{
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        }
    },
    mutations: {
        GET_MACHINE_PRODUCT : (state, res) => {
            state.machine_product_list = res.data;
            state.dataPaginate = {
                current_page : res.current_page,
                from : res.form,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            };
        },
        GET_MACHINE_PRODUCT_FORM : (state , res)=>{
            state.form = res;
        },
        CLEAR_FORM : (state)=>{
            state.form = {
                id : "",
                name : "",
                description: "",
                time_shot : ""
            }
        }
    },
    actions: {
        getMachine({commit},page=1){
            return Service.MachineProduct.getMachineProduct(page).then(response=>{
                commit("GET_MACHINE_PRODUCT",response)
            })
        },
        showMachineById({commit},id){
            return Service.MachineProduct.showMachineProduct(id).then(response=>{
                commit("GET_MACHINE_PRODUCT_FORM",response);
            })
        },
        saveMachine({commit,state},id){
            let data = {
                name : state.form.name,
                description: state.form.description,
                time_shot : state.form.time_shot
            };
            if(!id){ //create
                return Service.MachineProduct.createMachineProduct(data).then(()=>{
                    console.log("create success");
                });
            }
            else{ //update
                return Service.MachineProduct.updateMachineProduct(id,data).then(()=>{
                    console.log("create success");
                });
            }
        },
        deleteMachine({commit},id){
            return Service.MachineProduct.deleteMachineProduct(id).then(()=>{
                console.log("delete success");
            });
        },
        clearForm({commit}){
            commit("CLEAR_FORM")
        }
    }
};
export default machine;
